import { render, staticRenderFns } from "./BaseLayoutModifier.vue?vue&type=template&id=1344d460&"
import script from "./BaseLayoutModifier.vue?vue&type=script&lang=js&"
export * from "./BaseLayoutModifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports